// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PhoneNumber\ApiPhoneNumber.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PhoneNumberKind } from 'server/enums/PhoneNumberKind';

// PhoneNumberData is the class that PhoneNumber serializes to/from
export interface PhoneNumberData {
    Id : number;
    Url : string | null;
	
    OrganizationId : number;
    UserId : number;
	
    Guid : /* GUID */ string;
    Kind : PhoneNumberKind;
    Number : string;
}

// PhoneNumberOptions is the class which may be passed to the PhoneNumber constructor to define optional initial data values
export interface PhoneNumberOptions {
    Id : number;
    Url? : string | null;
	
    OrganizationId? : number;
    UserId? : number;
	
    Guid? : /* GUID */ string;
    Kind? : PhoneNumberKind;
    Number? : string;
}

export class PhoneNumber {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public OrganizationId : DataSignal<number>;
    public UserId : DataSignal<number>;
	
    public Guid : DataSignal<string>;
    public Kind : DataSignal<PhoneNumberKind>;
    public Number : DataSignal<string>;

    constructor();
    constructor(data : PhoneNumberOptions);
    constructor(data: PhoneNumberOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Kind = jsonableObservable(S.value<PhoneNumberKind>(data && data.Kind !== undefined ? data.Kind : 0));
        this.Number = jsonableObservable(S.value<string>(data && data.Number !== undefined ? data.Number : ''));
    }

    static key(obj : PhoneNumber) {
        return obj.Id();
    }
    
    static dataKey(obj : PhoneNumberOptions) {
        return obj.Id;
    }

    static update(obj : PhoneNumber, data : PhoneNumberOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Kind !== undefined) obj.Kind(data.Kind);
            if (data.Number !== undefined) obj.Number(data.Number);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PhoneNumber.ts